import errorPage from '../../assets/images/errors/banner_560x430_link non valido.svg';

import { Box } from '@mui/system';
import React from 'react';
import { GenericErrorTemplate } from '../../components/GenericErrorTemplate';
import { Button } from '@mui/material';

export const ErrorPage = () => {

    const description = (
        <Box>
            <p>
                L'indirizzo inserito non è valido oppure si è verificato un errore nell'apertura della pagina.
            </p>
            <p>
                Clicca sul pulsante sottostante per accedere a Easyfatt cloud. Se il problema persiste, contatta l'assistenza.
            </p>
        </Box>
    );

    return (
        <GenericErrorTemplate
            title="Attenzione!"
            description={description}
            image={{
                alt: "Generic error image",
                src: errorPage,
                style: {
                    width: 'auto',
                    height: '321px'
                }
            }}
            actions={
                <Button
                    variant="contained"
                    onClick={() => {
                        window.location.href = "/Account/OnPostLogin";
                    }}
                >
                    Accedi
                </Button>
            }
        />
    );
};